import { sortOptionsISelect } from "../helpers/sortISelect";
import { OperatingSystem } from "../model/enumerations/operating-system.model";
import { ISelect } from "../model/iSelect";

export const operationSystemEnum = (): Array<ISelect> => {
  const operationSystem: Array<ISelect> = [    
    {
      label: 'Ninguno',
      value: OperatingSystem.NONE,
    },
    {
      label: "Windows 10",
      value: OperatingSystem.WINDOWS_10,
    },
    {
      label: "Windows 8",
      value: OperatingSystem.WINDOWS_8,
    },
    {
      label: "Linux",
      value: OperatingSystem.LINUX,
    },
    {
      label: "Otro",
      value: OperatingSystem.OTHERS,
    },
  ];
  return sortOptionsISelect(operationSystem);
};
